<table mat-table [dataSource]="tools">
  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>Description</th>
    <td mat-cell *matCellDef="let element">{{ element?.description }}</td>
  </ng-container>
  <ng-container matColumnDef="btn">
    <th mat-header-cell *matHeaderCellDef></th>
    <td class="cell-right" mat-cell *matCellDef="let element">
      <button mat-flat-button color="primary" class="action-btn" (click)="launchTool(element)">
        <mat-icon>play_arrow</mat-icon>
        Lancer
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
